module.exports = __webpack_public_path__ + "img/audima.f67bf3ad.png";